import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalAgregarEmailAerovaleComponent } from "../modal-agregar-email-aerovale/modal-agregar-email-aerovale.component";
import { ModalConfirmComponent } from "src/app/shared/generic-modals/modal-confirm.component";
import { NotificacionesService } from "@abm/notificacion/notificaciones.service";
import { MessageService } from "@shell/message.service";
import { NgxSpinnerService } from "ngx-spinner";
import { FormControl, Validators } from "@angular/forms";
import { CustomValidatorsService } from "@shared/validators/custom-validators.service";

@Component({
  selector: "app-modal-email-aerovale",
  templateUrl: "./modal-email-aerovale.component.html",
  styleUrls: ["./modal-email-aerovale.component.scss"],
})
export class ModalEmailAerovaleComponent implements OnInit {  
  cargoAeroplantas: boolean = false;
  aeroplanta;
  aeroplantas;
  cargando: boolean = false;
  @Input() notificacionCliente;
  @Input() cuentaSgc;
  emailFormControl = new FormControl(null, [
    Validators.required,
    CustomValidatorsService.emailValidator,
  ]);

  constructor(
    private modal: NgbModal,
    private spinner: NgxSpinnerService,
    private notificacionesService: NotificacionesService,
    private messageService: MessageService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.obtenerAeroplantas();
  }

  mostrarSpinner() {
    this.cargando = true;
    this.spinner.show("spinnerGrafico");
  }

  ocultarSpinner() {
    this.cargando = false;
    this.spinner.hide("spinnerGrafico");
  }

  obtenerAeroplantas() {
    this.aeroplantas = null;
    this.mostrarSpinner();
    this.notificacionesService
      .obtenerNotificacionesEmailAerovales(
        this.cuentaSgc,
        this.notificacionCliente.tipoDocumento,
        this.notificacionCliente.numeroDocumento
      )
      .subscribe((res) => {
        this.aeroplantas = res.aeroplantas.sort((a, b) => {
          {
            if (a.nombre > b.nombre) {
              return 1;
            } else {
              return -1;
            }
          }
        });
        this.cargoAeroplantas = true;
        this.ocultarSpinner();
      });
  }

  agregarMailsNuevo() {
    const modalRef = this.modal.open(ModalAgregarEmailAerovaleComponent, {
      backdrop: "static",
      centered: true,
      size: "xl",
      windowClass: "myCustomModalClass",
    });
    modalRef.componentInstance.notificacionCliente = this.notificacionCliente;
    modalRef.componentInstance.configCorreoXAeroplanta = this.aeroplantas;
    modalRef.componentInstance.cuentaSgc = this.cuentaSgc;
    modalRef.result.then(
      () => {
        this.obtenerAeroplantas();
      }
    );
  }

  guardarCambios() {
    this.mostrarSpinner();
    this.notificacionCliente.notificaciones = [
      {
        aeroplantas: [
          {
            nombre: this.aeroplanta.nombre,
            codigoAeroplanta: this.aeroplanta.codigoAeroplanta,
            correosElectronicos: this.aeroplanta.correosElectronicos,
          },
        ],
        emails: this.aeroplanta.correosElectronicos,
        cuentaCliente: { cuentaSgc: this.cuentaSgc },
        documentos: [0],
        activo: true,
      },
    ];
    this.notificacionesService
      .actualizarNotificacionesEmailAerovales(this.notificacionCliente)
      .subscribe(() => {
        this.ocultarSpinner();
        this.messageService.showSuccessMessage(
          "Los cambios se guardaron exitosamente."
        );
        this.aeroplanta = null;
      });
  }

  cancelar() {
    this.activeModal.dismiss();
  }

  agregarMail(index) {
    if (this.email.invalid) {
      this.messageService.showErrorMessage(
        "El correo electrónico ingresado no es válido."
      );
      return;
    }
    this.aeroplantas[index].correosElectronicos.push(this.email.value);
    this.email.setValue(null);
  }

  borrarMail(mail, aeroplanta) {
    const modalRef = this.modal.open(ModalConfirmComponent, {
      centered: true,
      backdrop: "static",
    });
    modalRef.componentInstance.mensaje =
      "¿Seguro que desea eliminar el correo " +
      this.aeroplantas[aeroplanta].correosElectronicos[mail] +
      " de la aeroplanta " +
      this.aeroplantas[aeroplanta].nombre +
      "?";
    modalRef.result.then(
      () => {
        this.aeroplantas[aeroplanta].correosElectronicos.splice(mail, 1); //recibe el indice del mail a borrar
      }
    );
  }

  setGroup(i) {
    (i===null) ? this.aeroplanta = null : this.aeroplanta = this.aeroplantas[i];
  }

  get email() {
    return this.emailFormControl;
  }
}
